import { formatRequestOptions } from "./format";
import useRequest from "~/hooks/use-request";
import EventsAPI from "~/services/events";
import { ORDER, SORT } from "~/constants";

const formatTeam = (data: IResponseTeam): IModelTeam => {
  const runtimeConfig = useRuntimeConfig().public;
  const isEnableTeamShortName = runtimeConfig.APP_CUSTOMER.enable_teams_short_name;
  const title = isEnableTeamShortName && data.shortTitle ? data.shortTitle : data.title;

  return {
    id: data._id,
    referenceId: data.referenceId,
    title,
    imageUrl: data.logo,
    bannerUrl: data.banner,
    mainCategoryIds: data.identities?.map(i => i.type) || [],
    facebookUrl: data.socialMediasLinks?.facebook,
    instagramUrl: data.socialMediasLinks?.instagram,
    xUrl: data.socialMediasLinks?.twitter,
    webUrl: data.socialMediasLinks?.web,
  };
};

const TeamsAPI = {
  load(options?: IRequestPaginatedOptions & { leagueId?: string }): Promise<IModelTeam[]> {
    const { request } = useRequest();
    const params: IRequestPaginatedParams & { filters?: IRequestParamFilter } = formatRequestOptions(options);

    if (options?.leagueId) {
      if (params.filters)
        params.filters["identities.type"] = options?.leagueId;
      else
        params.filters = { "identities.type": options?.leagueId };
    }

    params.order = ORDER.asc;
    params.sort = SORT.title;

    return request
      .post<IPaginatedResponse<IResponseTeam>>("/api/team/list", { body: params })
      .then(response => response.content.entries.map(formatTeam));
  },

  loadById(teamId: string, options?: { loadTotals: boolean }): Promise<IModelTeam> {
    const { request } = useRequest();

    return request
      .get<IContentResponse<IResponseTeam>>(`/api/team/get_by_id/id/${teamId}`)
      .then(async (response) => {
        const team = formatTeam(response.content);

        if (options?.loadTotals) {
          const params = { countOnly: true, teamId };

          await Promise.all([
            EventsAPI.load({ ...params, type: "archived" }), // latest events
            EventsAPI.load({ ...params, type: "upcoming" }), // upcoming events
            EventsAPI.load({ ...params, type: "live" }), // live events
          ]).then(([res1, res2, res3]) => {
            team.totalVodEventsNumber = res1.content.count;
            team.totalUpcomingEventsNumber = res2.content.count;
            team.totalLiveEventsNumber = res3.content.count;
            team.totalEventsNumber = team.totalVodEventsNumber + team.totalUpcomingEventsNumber + team.totalLiveEventsNumber;
          });
        }

        return team;
      });
  },
};

export default TeamsAPI;
